import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageUploader, WidgetProps } from '@/components';
import {
  AvatarDto,
  useTaskControllerGetTaskParticipantDataQuery,
  useTaskControllerJoinTaskMutation,
} from '@/store/services/MidleNestApi.service';
import { useRemainingTime, useTaskQue } from '@/hooks';

interface Props extends WidgetProps {
  taskId: string;
  title?: string;
  description?: string;
  avatar?: string;
  visitUrl: string;
  endDate: string;
  reloadOnVerify?: boolean;
}

export default function SubmitFileView({
  taskId,
  visitUrl,
  title,
  description,
  avatar,
  endDate,
  reloadOnVerify = false,
}: Props) {
  // TODO: Admin Tarafindan task onaylandiktan sonra taskIdler queue icerisinden silinemiyor ve localStorage da kaliyor.
  const { setIsCustomerWaiting, removeFromCustomerWaiting } = useTaskQue(taskId);

  const { data, isLoading } = useTaskControllerGetTaskParticipantDataQuery(taskId);
  const visitUrls = visitUrl.split(',');
  const { t } = useTranslation();
  const [mutation] = useTaskControllerJoinTaskMutation();
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const remainingTime = useRemainingTime(endDate);

  const handleUpload = useCallback(async () => {
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append('file', file);
      // formData.append('campaignId', id ? id : '');
      mutation({ id: taskId, body: formData as { file?: Blob } })
        .unwrap()
        .then(() => {
          setFile(null);
          setIsCustomerWaiting();
          if (reloadOnVerify) {
            window.location.reload();
          }
          // hideModal();
          // navigate(-1);
        });
    } catch (err) {
      console.error(err);
    }
  }, [file]);
  return (
    <>
      <div className='flex flex-col gap-y-0 max-w-[550px]'>
        <div className='flex items-center'>
          <img src={avatar} className='w-14 h-14 rounded-full' />
          <div className='font-semibold text-xl ml-3'>{title}</div>
        </div>

        <div className='my-3 bg-[#655A38] w-full h-[1px]' />

        <div className='text-sm'>{description}</div>

        {visitUrls &&
          visitUrls.map((url, index) => (
            <span className='underline dark:text-[#FFDA68]' key={index}>
              <a
                target='_blank'
                href={url.includes('http') ? url : 'https://' + url}
                rel='noreferrer'
              >
                {url}
              </a>
            </span>
          ))}

        <div className='w-full rounded-xl border dark:border-[#FFDA68] dark:text-[#FFDA68] flex flex-col items-center pt-2 pb-3 mt-5'>
          <div className='text-xl font-semibold'>{t('Remaining Time')}</div>
          <div className='flex space-x-2'>
            <div className='flex flex-col items-center'>
              <div className='text-[40px] font-semibold'>{remainingTime.days}</div>
              <div>{t('Days')}</div>
            </div>

            <div className='text-[40px] font-semibold'>:</div>

            <div className='flex flex-col items-center'>
              <div className='text-[40px] font-semibold'>{remainingTime.hours}</div>
              <div>{t('Hours')}</div>
            </div>

            <div className='text-[40px] font-semibold'>:</div>

            <div className='flex flex-col items-center'>
              <div className='text-[40px] font-semibold'>{remainingTime.minutes}</div>
              <div>{t('Minutes')}</div>
            </div>
          </div>
        </div>

        <div className='mx-auto my-auto'>
          <ImageUploader
            setFile={setFile}
            file={file}
            src={data && 'avatar' in data.data ? (data.data.avatar as AvatarDto).src : ''}
            // setError={setError}
            // defaultError={fileError}
            // file={file}
          />
        </div>
        <div className='w-max mx-auto'>
          <button
            onClick={() => handleUpload()}
            type='button'
            className='btn btn-ok disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50 w-max dark:border-[#FFDA68] border-blue-500 text-blue-500 !px-14 dark:text-[#FFDA68]'
            disabled={!file}
          >
            {t('Verify')}
          </button>
        </div>
      </div>
    </>
  );
}
